import React from 'react';
import PropTypes from 'prop-types';
import { getOr, omit } from 'lodash/fp';
import { Grid, Row, Col, Icon, Input, Button, SelectPicker } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { portalUsersOnClear } from '../../../../redux/Settings/actions/portal/user';
import { getIsFetching } from '../../../../redux/Settings/selectors/portal/user';
import {
  onChangeQuery,
  onClearQuery
} from '../../../../redux/Settings/actions/components/portal/user-search';
import { fetchPortalUsers } from '../../../../redux/sagas/routines';
import { getPaginationQueryOptions } from '../../../../redux/Settings/selectors/portal/user/pagination';
import { getSettingsPortalUserSearchQuery } from '../../../../redux/Settings/selectors/components/portal/user-search';

const VerifiedOptions = [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }];

const UserSearch = ({ placeholder }) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const searchQuery = useSelector(getSettingsPortalUserSearchQuery);
  const paginationQuery = useSelector(getPaginationQueryOptions);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };

  const handleSubmit = () => {
    dispatch(portalUsersOnClear());
    dispatch(fetchPortalUsers(queryOptions));
  };

  const handleOnChangeQuery = q => {
    if (q) dispatch(onChangeQuery({ ...searchQuery, q }));
    else dispatch(onChangeQuery(omit('q', searchQuery)));
  };

  const handleOnChangeIsVerified = isVerified => {
    if (isVerified === null)
      dispatch(onChangeQuery(omit('isVerified', searchQuery)));
    else dispatch(onChangeQuery({ ...searchQuery, isVerified }));
  };

  const handleOnClear = () => {
    dispatch(onClearQuery());
    dispatch(portalUsersOnClear());
    dispatch(fetchPortalUsers());
  };

  return (
    <Grid fluid style={{ padding: 0, marginLeft: 0 }}>
      <Row gutter={8}>
        <Col xs={4}>
          <Input
            value={getOr('', 'q', queryOptions)}
            onChange={handleOnChangeQuery}
            style={{ paddingLeft: 10 }}
            placeholder={placeholder}
            onKeyPress={({ key }) => {
              if (key === 'Enter') handleSubmit();
            }}
          />
        </Col>

        <Col xs={3}>
          <SelectPicker
            style={{ width: '100%', marginRight: 10 }}
            value={getOr('', 'isVerified', queryOptions)}
            data={VerifiedOptions}
            appearance="default"
            placeholder="Filter Verified"
            onChange={handleOnChangeIsVerified}
          />
        </Col>

        <Col xs={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            color="green"
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={isFetching}
            onClick={handleSubmit}
          >
            <Icon icon="search" /> Search
          </Button>
          <Button
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={isFetching}
            onClick={handleOnClear}
          >
            <Icon icon="refresh" /> Reset
          </Button>
        </Col>
      </Row>
    </Grid>
  );
};

UserSearch.propTypes = {
  placeholder: PropTypes.string.isRequired
};

export default UserSearch;
